export default {
  required: 'The {_field_} is required',
  email: 'Please enter a valid email addressssss',
  phone: 'Please enter a valid phone number',
  numeric: 'The {_field_} must be a number',
  confirmed: 'Password does not match',
  min: 'The {_field_} must be at least {length} numbers',
  max: 'The {_field_} may not be greater than {length} numbers',
};